import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { generatePath, useNavigate, useSearchParams } from "react-router-dom";
import LoadingSpinner from "../../components/loaders/LoadingSpinner";
import {
  ROUTE_ARTICLES,
  ROUTE_DESTINATIONS,
  ROUTE_DESTINATIONS_EDIT,
} from "../../constants/routes";
import {
  DestinationTabs,
  DestinationTypeEnum,
  DestinationTypeMap,
} from "../../enums/destination";

// Where the browser lands after Google's consent screen: /google/connected?google=connected|error[&destination_id=...]
// (set GOOGLE_OAUTH_SUCCESS_REDIRECT on the server to this page's url)
const GoogleConnected = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const connected = params.get("google") === "connected";
    const destinationId = params.get("destination_id");
    // a destination flow, also when it failed: a failed "create" has no destination, because nothing is saved
    const isDestinationFlow = params.get("flow") === "destination";

    if (connected) {
      toast.success("Google account connected.");
    } else {
      toast.error(
        isDestinationFlow && !destinationId
          ? "Could not connect your Google account, so the destination was not saved. Please try again."
          : "Could not connect your Google account. Please try again."
      );
    }

    navigate(
      destinationId
        ? generatePath(ROUTE_DESTINATIONS_EDIT, { id: destinationId }) +
            `?type=${DestinationTypeMap[DestinationTypeEnum.GOOGLE_DOCS]}`
        : isDestinationFlow
          ? ROUTE_DESTINATIONS + `?tab=${DestinationTabs.ALL}`
          : ROUTE_ARTICLES,
      { replace: true }
    );
    // runs once, on landing
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h-[50%] flex justify-center items-center">
      <LoadingSpinner size="32px" />
    </div>
  );
};

export default GoogleConnected;
